import { z } from 'zod';
import { command, get, post } from '../http';
import { type ListQuery, paginated, resource } from '../schemas/common';
import { newsItemSchema, ticketSchema } from '../schemas/domain';

export const ticketInput = z.object({
  subject: z.string().min(4, 'Subject is required'),
  category: z.string().min(1, 'Choose a category'),
  priority: z.enum(['low', 'normal', 'high']).default('normal'),
  message: z.string().min(10, 'Describe your issue in at least 10 characters'),
});
export type TicketInput = z.infer<typeof ticketInput>;

export const replyInput = z.object({
  message: z.string().min(1, 'Reply cannot be empty'),
});
export type ReplyInput = z.infer<typeof replyInput>;

export const supportApi = {
  create: (input: TicketInput) => post('/support/tickets', resource(ticketSchema), input),
  list: (query: ListQuery = {}) => get('/support/tickets', paginated(ticketSchema), query),
  show: (id: string) => get(`/support/tickets/${id}`, resource(ticketSchema)),
  reply: (id: string, input: ReplyInput) => command(`/support/tickets/${id}/reply`, input),
  close: (id: string) => command(`/support/tickets/${id}/close`),

  news: () => get('/news', resource(z.array(newsItemSchema))),

  /* admin */
  adminList: (query: ListQuery = {}) => get('/admin/tickets', paginated(ticketSchema), query),
  adminShow: (id: string) => get(`/admin/tickets/${id}`, resource(ticketSchema)),
  adminReply: (id: string, input: ReplyInput) => command(`/admin/tickets/${id}/reply`, input),
};
